<template>
  <div class='wrapper-page' v-if="toggles('my_shared_folders')">
    <my-share-folder-form ref='myShareFolderForm' @success='getMySharedFolders()'/>
    <bulk-edit-sharing ref='bulkShareFolderForm' @success='getMySharedFolders' :folders="bulkOpFolders"/>

    <modal ref="modalRevokeAllForm">
      <template #header>
        <h5 class='modal-title mt-0'>
          {{ $t('folders_list.revoke_all.title', {folderName: current_folder.name || ''}) }}
        </h5>
      </template>
      <template #body>
        <form>
          <div class='modal-body'>
            <p>{{ $t('folders_list.revoke_all.are_you_sure') }}</p>
            <p>
              {{ $t('folders_list.revoke_all.consequences') }}
              <br/>
              {{ $t('folders_list.revoke_all.consequences_action_one') }}
              <br/>
              {{ $t('folders_list.revoke_all.consequences_action_two') }}
            </p>
          </div>
          <div class='modal-footer'>
            <input @click.prevent='$refs.modalRevokeAllForm.close' type='submit'
                   :value="$t('folder_show.modals.delete_file.cancel')" class='btn btn-outline-primary'>
            <input type='button' :value="$t('folders_list.revoke_all.submit')" @click.prevent='revokeMySharedFolders'
                   class='btn btn-danger' :disabled="isDisabled"/>
          </div>
        </form>
      </template>
    </modal>

    <modal ref="modalBulkRevokeAllForm">
      <template #header>
        <h5 class='modal-title mt-0'>
          {{ $t('folders_list.revoke_all.title_bulk', {foldersCount: bulkOpFolders.length || ''}) }}
        </h5>
      </template>
      <template #body>
        <form>
          <div class='modal-body'>
            <p>{{ $t('folders_list.revoke_all.are_you_sure_bulk', {foldersCount: bulkOpFolders.length || ''}) }}</p>
            <p>
              {{ $t('folders_list.revoke_all.consequences') }}
              <br/>
              {{ $t('folders_list.revoke_all.consequences_action_one') }}
              <br/>
              {{ $t('folders_list.revoke_all.consequences_action_two') }}
            </p>
          </div>
          <div class='modal-footer'>
            <input @click.prevent='$refs.modalBulkRevokeAllForm.close' type='submit'
                   :value="$t('folder_show.modals.delete_file.cancel')" class='btn btn-outline-primary'>
            <input type='button' :value="$t('folders_list.revoke_all.submit')"
                   @click.prevent='revokeBulkMySharedFolders' class='btn btn-danger' :disabled="isDisabled"/>
          </div>
        </form>
      </template>
    </modal>

    <modal ref='bulkSharingLinkForm' class="sharing-modal">
      <template #header>
        <h5 class="modal-title mt-0">
          <img src="../assets/shareable-link.svg"/>
          {{ $t('folders.my_shared_folders.title_edit_links', {foldersCount: bulkOpFolders.length || ''}) }}
        </h5>
      </template>
      <template #body>
        <div class='modal-body'>
          <div v-if="unverifiedUser" class="unverified-info">
            <p>
              {{ $t('verify.info_send_1') }} <strong> {{ $t('verify.info_send_2') }} </strong>
              {{ $t('verify.info_share_3') }}
              <br>
              {{ $t('verify.info_part_2') }}
            </p>
          </div>
          <div class="shareable-link-wrapper">
            <div class="row p-3">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 form-group">
                    <div class="btn-group dropdown" role="group" aria-expanded="false">
                      <button :class="['btn', 'btn-neutral', 'dropdown-toggle', { disabled: processing_links }]"
                              aria-expanded="false"
                              aria-haspopup="true" data-toggle="dropdown">
                        <span v-if="processing_links">
                          {{ $t('share_invite.bulk_get_shareable_link_processing') }}
                          <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                        <span v-else>
                          {{ $t('records_list.dropdown.manage_links') }}
                        </span>
                      </button>

                      <div class="dropdown-menu">
                        <ul>
                          <li v-if="shared.length > 0">
                            <a href="#" @click.prevent="sharingLinkToggle(false)" class="dropdown-item">
                              {{ $t('share_invite.bulk_remove_shareable_link', {foldersCount: shared.length}) }}
                            </a>
                          </li>
                          <li v-if="notShared.length > 0">
                            <a href="#" @click.prevent="sharingLinkToggle(true)" class="dropdown-item">
                              {{ $t('share_invite.bulk_get_shareable_link', {foldersCount: notShared.length}) }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row p-3">
              <form @submit.prevent="submitPasswordForm($event)">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12" v-if="submit_password_set">
                      {{ $t('share_invite.pass_set') }}
                      ( <a href="#" @click.prevent="submit_password_set = false">
                      {{ $t('share_invite.change') }}</a> )
                    </div>
                    <div class="col-md-12" v-else>
                      <label>{{ $t('share_invite.add_pass_bulk') }}</label>
                      <div class="input-group">
                        <input type="password" name="folder[password]" id="folder-password" class="form-control"
                               v-model="password" v-focus :placeholder="$t('share_invite.type_pass')">
                        <div class="input-group-append">
                          <button type="submit" class="btn btn-outline-primary btn-sm" :disabled="password.length < 4">
                            {{ $t('share_invite.save') }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </form>
            </div>
            <div class="row p-3">
              <form>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 form-group" v-if="expired_at === ''">
                      <label>{{ $t('share_invite.add_exp_date_bulk') }}</label>
                      <div class="input-group">
                        <datepicker ref="expDatepicker" :value="expired_at" @selected="submitExpirationDateForm"
                                    :disabled-dates="{to: new Date()}"
                                    input-class="form-control expiration-input"></datepicker>
                        <div class="input-group-append" @click.prevent="datepickerFocus()">
                          <span class="input-group-text"><i class="fas fa-calendar"></i></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-else>
                      {{ $t('share_invite.link_expires_on_bulk', {date: formatDate(expired_at)}) }} ( <a href="#"
                                                                                                         @click="expired_at = ''">{{
                        $t('share_invite.change_date')
                      }}</a> )
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <small>
                        {{ $t('share_invite.time_zone') }}
                      </small>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class='modal-footer'>
          <input @click.prevent='$refs.bulkSharingLinkForm.close' type='submit' :value="$t('share_invite.close')" class='btn btn-outline-primary'>
        </div>
      </template>
    </modal>

    <div class='container-fluid'>
      <h1 class="page-title">
        {{ $t('folders.my_shared_folders.shared_folders') }}
      </h1>
      <div class="clearfix"></div>

      <div class="btn-group float-right show-hide-columns m-b-10" role="group" v-click-outside="closeShowHideDropdown">
        <button class="btn btn-neutral dropdown-toggle" v-on:click="openShowHideDropdown = !openShowHideDropdown">
          {{ $t('contacts.show_hide_columns') }}
        </button>

        <ul class="dropdown-menu dropdown-menu-right" v-if="openShowHideDropdown">
          <li class="dropdown-item" @click="toggleColumns('name')">
            <input type="checkbox" :checked="mySharedFolderColumns['name']" />
            {{ $t('folders.my_shared_folders.show_hide.name') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('contact_connection')">
            <input type="checkbox" :checked="mySharedFolderColumns['contact_connection']" />
            {{ $t('folders.my_shared_folders.show_hide.contact_connection') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('folder_creator')">
            <input type="checkbox" :checked="mySharedFolderColumns['folder_creator']" />
            {{ $t('folders.my_shared_folders.show_hide.folder_creator') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('sharing_type')">
            <input type="checkbox" :checked="mySharedFolderColumns['sharing_type']" />
            {{ $t('folders.my_shared_folders.show_hide.sharing_type') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('sharing_contacts')">
            <input type="checkbox" :checked="mySharedFolderColumns['sharing_contacts']" />
            {{ $t('folders.my_shared_folders.show_hide.shared_with') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('sharing_permissions')">
            <input type="checkbox" :checked="mySharedFolderColumns['sharing_permissions']" />
            {{ $t('folders.my_shared_folders.show_hide.sharing_permissions') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('sharing_options')">
            <input type="checkbox" :checked="mySharedFolderColumns['sharing_options']" />
            {{ $t('folders.my_shared_folders.show_hide.sharing_options') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('actions')">
            <input type="checkbox" :checked="mySharedFolderColumns['actions']" />
            {{ $t('folders.my_shared_folders.show_hide.actions') }}
          </li>
          <li>
            <button class="btn btn-primary float-right m-r-10 m-b-10" v-on:click="openShowHideDropdown = false">
              {{ $t('contacts.edit_modal.save') }}
            </button>
          </li>
        </ul>
      </div>

      <filter-list />

      <filter-list-from-params />

      <div id='folders-list' class="text-center">
        <div :class="['bulk-container', { 'hide': !isBulkEnabled  }]">
          <span> {{ bulkOpFolders.length }} {{ $t('root.folders') }}</span>
          <ul>
            <li>
              <a @click.prevent="openBulkSharingLinkFormModal()" href="#" class="dropdown-item">
                <i class="fas fa-link"></i>
                {{ $t('folders.my_shared_folders.edit_sharing_link_access') }}
              </a>
            </li>
            <li>
              <a @click.prevent="$refs.bulkShareFolderForm.open()" href="#" class="dropdown-item">
                <i class="fas fa-edit"></i>
                {{ $t('folders.my_shared_folders.edit_sharing') }}
              </a>
            </li>
            <li>
              <a @click.prevent="$refs.modalBulkRevokeAllForm.open(bulkOpFolders)" href="#" class="dropdown-item">
                <i class="fas fa-users-slash"></i>
                {{ $t('folders.my_shared_folders.revoke') }}
              </a>
            </li>
          </ul>
        </div>

        <div class="table_wrapper" v-if="mySharedFolders.length > 0">
          <table class="table">
            <thead>
            <tr>
              <th><input type='checkbox' @input='selectAll'/></th>
              <th></th>
              <th v-if="mySharedFolderColumns['name']">{{ $t('folders.list.folder_name') }}</th>
              <th v-if="mySharedFolderColumns['contact_connection']">{{ $t('folders.list.contact_name') }}</th>
              <th v-if="mySharedFolderColumns['folder_creator']">{{ $t('folders.my_shared_folders.folder_creator') }}</th>
              <th v-if="mySharedFolderColumns['sharing_type']">{{ $t('folders.my_shared_folders.type_of_sharing') }}</th>
              <th v-if="mySharedFolderColumns['sharing_contacts']">{{ $t('folders.my_shared_folders.shared_with') }}</th>
              <th v-if="mySharedFolderColumns['sharing_permissions']">{{ $t('folders.my_shared_folders.sharing_permissions') }}</th>
              <th v-if="mySharedFolderColumns['sharing_options']">{{ $t('folders.my_shared_folders.sharing_options') }}</th>
              <th v-if="mySharedFolderColumns['actions']">{{ $t('folders.my_shared_folders.actions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for='folder in mySharedFolders' :key='folder.id'>
              <td class="bulk-check">
                <input type='checkbox' v-model='bulkOpFolders' :value='folder'/>
              </td>
              <td class="data-img">
                <router-link :to="{ name: 'folder', params: { id: folder.id } }">
                  <img alt="Folder" src="../assets/folders-icon.svg"/>
                </router-link>
              </td>
              <td v-if="mySharedFolderColumns['name']">
                <router-link :to="{ name: 'folder', params: { id: folder.id } }">
                  {{ folder.name }}
                </router-link>
              </td>
              <td v-if="mySharedFolderColumns['contact_connection']">
                <router-link :to="{ name: 'contact_folders', params: { id: folder.contact.id } }" v-if='folder.contact.id'>
                  {{ contactTemplate(folder.contact) }}
                </router-link>
              </td>
              <td v-if="mySharedFolderColumns['folder_creator']">
                {{ contactTemplate(folder.user) }}
              </td>
              <td v-if="mySharedFolderColumns['sharing_type']">
                <ul>
                  <li v-if='shareInvitesByFolder[folder.id]'>
                    {{ $t('folders.my_shared_folders.filters.email_sharing') }}
                  </li>
                  <li v-if='folder.shared'>
                    {{ $t('folders.my_shared_folders.filters.link_sharing') }}
                  </li>
                </ul>
              </td>
              <td v-if="mySharedFolderColumns['sharing_contacts']">
                <ul v-for="invite in shareInvitesByFolder[folder.id]">
                  <li>
                    <router-link :to="{ name: 'contact_folders', params: { id: invite.contact.id } }">
                      {{ contactTemplate(invite.contact) }}
                    </router-link>
                  </li>
                </ul>
              </td>
              <td v-if="mySharedFolderColumns['sharing_permissions']">
                <ul v-for="invite in shareInvitesByFolder[folder.id]">
                  <li>
                    <span v-if="invite.invite_type == 'read'">{{ $t('folders.my_shared_folders.filters.view_perm') }}</span>
                    <span v-if="invite.invite_type == 'all'">{{ $t('folders.my_shared_folders.filters.edit_options_perm') }}</span>
                    <span v-if="invite.invite_type == 'write'">{{ $t('folders.my_shared_folders.filters.edit_perm') }}</span>
                  </li>
                </ul>
              </td>
              <td v-if="mySharedFolderColumns['sharing_options']">
                <div>
                  <ul>
                    <li>
                      {{ folder.has_password ? $t('folders.my_shared_folders.filters.pass_set') : $t('folders.my_shared_folders.filters.no_pass_set') }}
                    </li>
                    <li>
                      {{ folder.sharing_expired_at ? $t('folders.my_shared_folders.filters.exp_date_set') : $t('folders.my_shared_folders.filters.no_exp_date_set') }}
                    </li>
                  </ul>
                </div>
              </td>
              <td class="dropdown-column" v-if="mySharedFolderColumns['actions']">
                <div class="dropdown">
                  <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" type="button"
                          class="btn dropdown-toggle">· · ·
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul>
                      <li>
                        <a href='#' class="dropdown-item" @click.prevent='$refs.myShareFolderForm.openModal(folder.id)'>
                          <i class="fas fa-edit"></i>
                          {{ $t('folders.my_shared_folders.edit_sharing') }}
                        </a>
                      </li>
                      <li>
                        <a href='#' class="dropdown-item" @click.prevent='modalRevokeAllOpen(folder)'>
                          <i class="fas fa-users-slash"></i>
                          {{ $t('folders.my_shared_folders.revoke') }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="clearfix"></div>

        <loading v-if="loading" class="m-t-60"/>

        <div class="empty-list-wrapper" v-else>
          <div v-if="hasFilters && mySharedFolders.length === 0" class="empty-list-wrapper">
            <img src="../assets/empty_states/shared_with_me.png"/>
            <p>
              {{ $t('folders.my_shared_folders.no_filters') }}
              <router-link :to='{ query: {} }'>
                {{ $t('records_list.clear_filters') }}
              </router-link>
            </p>
          </div>

          <div v-if='mySharedFolders.length === 0 && !hasFilters' class="empty-list-wrapper">
            <img src="../assets/empty_states/shared_with_me.png"/>
            <p>{{ $t('folders.my_shared_folders.no_folders') }}</p>
          </div>
        </div>
      </div>

      <pagination :meta='meta'/>
    </div>
  </div>
</template>
<script>
import _datepicker from 'vuejs-datepicker'

import _modal from '../components/_modal'
import _loading from '../components/_loading'
import _pagination from '../components/_pagination'

import _multi_select from '../components/shared/_infinite_multi_select'
import _filter_list from '../components/filters/sharing/_filter_list_for_my_shared_folders'
import _filter_list_from_params from '../components/filters/sharing/_my_shared_folder_filter_list_from_params'

import _share_folder_form from '../components/folders/_my_sharing_modal'
import _bulk_edit_sharing from '../components/folders/_bulk_my_sharing_modal'

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.toggles('my_shared_folders')) {
        vm.$router.push({name: 'home'})
      }
    })
  },
  components: {
    modal: _modal,
    loading: _loading,
    pagination: _pagination,
    datepicker: _datepicker,
    'filter-list': _filter_list,
    'filter-list-from-params': _filter_list_from_params,
    'multi-select': _multi_select,
    'my-share-folder-form': _share_folder_form,
    'bulk-edit-sharing': _bulk_edit_sharing,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  created() {
    if (!this.toggles('my_shared_folders'))
      return

    this.getMySharedFolders()
    this.store.sendMetrics({name: 'my_shared_folders', params: this.$route.params, path: this.$route.fullPath})
  },
  data() {
    return {
      password: '',
      expired_at: '',
      loading: false,
      openShowHideDropdown: false,
      bulkOpFolders: [],
      current_folder: {},
      isDisabled: false,
      submit_password_set: false,
      processing_links: false
    }
  },
  watch: {
    query() {
      this.getMySharedFolders()
      this.store.sendMetrics({name: 'my_shared_folders', params: this.$route.params, path: this.$route.fullPath})
    }
  },
  computed: {
    mySharedFolders() {
      return this.state.mySharedFolders || []
    },
    shareInvitesByFolder() {
      if (!this.stats.shareInvites)
        return {}

      const res = {}
      this.stats.shareInvites.forEach(i => {
        res[i.folder_id] = (res[i.folder_id] || []).concat(i)
      })
      return res
    },
    sharedWithContacts() {
      return this.lists.sharedWithContacts || []
    },
    connectedContacts() {
      return this.lists.connectedContacts || []
    },
    users() {
      return this.lists.users || []
    },
    mySharedFolderColumns() {
      if (!this.userDefaults.my_shared)
        return {}

      const cols = {}
      this.userDefaults.my_shared.forEach(c => cols[c] = true)
      return cols
    },
    isBulkEnabled() {
      return this.bulkOpFolders.length > 0
    },
    shared() {
      return this.bulkOpFolders.filter(i => i.shared)
    },
    notShared() {
      return this.bulkOpFolders.filter(i => !i.shared)
    },
  },
  methods: {
    folderIds() {
      return this.bulkOpFolders.map(f => f.id)
    },
    modalRevokeAllOpen(folder) {
      this.$refs.modalRevokeAllForm.open()
      this.current_folder = folder
    },
    revokeMySharedFolders() {
      this.loading = true
      this.isDisabled = true
      this.store.sendMetrics({
        name: 'my_shared_folders_revoke_all',
        params: this.$route.params,
        path: this.$route.fullPath
      })
      return this.store.revokeMySharedFolders(this.current_folder.id).then(() => {
        this.isDisabled = false
        this.getMySharedFolders()
        this.$refs.modalRevokeAllForm.close()
        this.$toastr.success(this.$t('folders.my_shared_folders.sharing_revoked'))
      }).catch((err) => {
        this.isDisabled = false
      })
    },
    revokeBulkMySharedFolders() {
      this.loading = true
      this.isDisabled = true
      this.store.sendMetrics({
        name: 'my_shared_folders_bulk_revoke_all',
        params: this.$route.params,
        path: this.$route.fullPath
      })
      return this.store.revokeBulkMySharedFolders(this.folderIds()).then(() => {
        this.isDisabled = false
        this.getMySharedFolders()
        this.$refs.modalBulkRevokeAllForm.close()
        this.$toastr.success(this.$t('folders.my_shared_folders.success_bulk_revoke'))
      }).catch((err) => {
        this.isDisabled = false
      })
    },
    getMySharedFolders() {
      this.loading = true
      return this.store.getMySharedFolders(this.query).then(() => {
        this.loading = false
        this.statStore.getShareInvites({ 'filters[folder_id_in]': this.mySharedFolders.map(f => f.id) })
        this.updateBulkOptions()
      })
    },
    updateBulkOptions() {
      if (this.bulkOpFolders.length == 0)
        return

      const bulkIds = this.bulkOpFolders.map(f => f.id)
      this.bulkOpFolders = this.mySharedFolders.slice().filter((item) => bulkIds.includes(item.id))
    },
    closeShowHideDropdown() {
      this.openShowHideDropdown = false
    },
    openBulkSharingLinkFormModal() {
      this.submit_password_set = false
      this.expired_at = ''
      this.$refs.bulkSharingLinkForm.open()
    },
    toggleColumns(column) {
      let newMySharedColumns = this.mySharedFolderColumns

      if (this.mySharedFolderColumns[column])
        delete newMySharedColumns[column]
      else
        newMySharedColumns[column] = true

      const newDefaults = Object.assign({}, this.currentUser.defaults, { my_shared: Object.keys(newMySharedColumns) })
      this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
        this.store.getCurrentUser()
      })
    },
    selectAll(e) {
      if (e.target.checked) {
        this.bulkOpFolders = this.mySharedFolders.slice()
      } else {
        this.bulkOpFolders = []
      }
    },
    submitPasswordForm(e) {
      if (this.password.length == 0) {
        this.$toastr.alert(this.$t('share_invite.pls_provide_pass'))
        return
      }

      let formData = {folder: {password: this.password}, ids: this.folderIds()}
      this.password = ''

      this.axios.post('/folders/bulk_sharing', formData).then(() => {
        this.submit_password_set = true
        this.getMySharedFolders()
        this.$toastr.success(this.$t('shared.updated_successfully'))
        this.store.sendMetrics({
          name: 'add_folder_share_password_bulk',
          formData: this.$route.params,
          path: this.$route.fullPath
        })
      })
    },
    submitExpirationDateForm(selected_date) {
      let formData = {folder: {sharing_expired_at: selected_date}, ids: this.folderIds()}
      this.axios.post('/folders/bulk_sharing', formData).then(({data}) => {
        if (selected_date) {
          this.expired_at = selected_date
          this.getMySharedFolders()
          this.$toastr.success(this.$t('shared.updated_successfully'))
          this.store.sendMetrics({
            name: 'add_folder_sharing_expiration_bulk',
            params: this.$route.params,
            path: this.$route.fullPath
          })
        }
      })
    },
    datepickerFocus() {
      $('#folder-sharing-expired-at').focus()
    },
    sharingLinkToggle(switcher) {
      if (switcher === false) {
        this.submit_password_set = false
        this.expired_at = ''
      }
      let formData = {folder: {shared: String(switcher)}, ids: this.folderIds()}
      this.processing_links = true

      this.axios.post(`/folders/bulk_sharing`, formData)
          .then(response => {
            this.$toastr.success(this.$t('shared.updated_successfully'))
            this.getMySharedFolders()
            this.processing_links = false
            this.store.sendMetrics({
              name: 'add_remove_sharing_link_bulk',
              params: this.$route.params,
              path: this.$route.fullPath
            })
          })
    },
    getSharedWithContacts(params) {
      return this.listStore.getSharedWithContacts(params)
    },
    getConnectedContacts(params) {
      return this.listStore.getConnectedContacts(params)
    },
    getUsers(params) {
      return this.listStore.getUsers(params)
    },
    getSharedFolders(params) {
      return this.listStore.getMySharedFolders(params)
    },
  }
}
</script>
<style lang="sass" scoped>
ul
  list-style: none
  padding: 0
  margin: 0
table
  tbody
    height: 250px
    overflow-y: auto
.filter-shared
  form
    label
      display: block
    input[type=checkbox]
      margin-right: 3px
</style>
